import { config } from '@services/config';
import type { UnderwritingRulesGetRequestQuery, UnderwritingRulesGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUnderwritingRules = ({
  offeringId,
  pageLimit,
  pageOffset,
  underwritingLabel,
  id,
  isDeprecated,
}: UnderwritingRulesGetRequestQuery) => {
  const client = useClient();

  const params = new URLSearchParams();
  if (offeringId) params.append('offeringId', offeringId);
  if (pageLimit) params.append('pageLimit', String(pageLimit));
  if (pageOffset) params.append('pageOffset', String(pageOffset));
  if (underwritingLabel) params.append('underwritingLabel', underwritingLabel);
  if (id) params.append('id', id);
  if (isDeprecated !== undefined && isDeprecated !== null) params.append('isDeprecated', String(isDeprecated));
  const result = useQuery<UnderwritingRulesGetResponse, Error>({
    queryKey: ['underwritingRules', { offeringId, pageLimit, pageOffset, underwritingLabel, id, isDeprecated }],
    queryFn: () => client.get(`underwriting-rule?${String(params)}`).json<UnderwritingRulesGetResponse>(),
    ...config,
  });
  return { ...result, underwritingRule: result.data };
};
